import router from '@/router'
import { firebase } from '@/util/firebase'
import { firebaseInstance } from '@/util/firebase'
import { getAuth, signInAnonymously } from "firebase/auth";
import http from '@/util/http'
import axios from 'axios'
require('firebase/functions')

import { EmailAuthProvider } from "firebase/auth";

let global_news_path = 'globalNews/'

let unAuthedPaths = [
  '/',
  '/login',
  '/signup',
  '/?auth=login'
]
let authedPaths = [
  // '/about',
  // '/terms',
  // '/security',
  // '/how-it-works',
  // '/support',
  // '/privacy',
]


let my_coffees_ref = '/myCoffees/'
let my_current_cupping = '/myCurrentCupping/'

let my_products_path = 'myLiveCuppings/'
let my_recently_viewed_sessions = 'myRecentlyViewedSessions/'
let public_products_path = 'publicLiveCuppings/'
let my_display_data = 'displayDataByUser/'
let order_update_path = 'orderUpdates/'
let customer_info_path = 'customer_info/public/'
let customer_info_path2 = 'customer_info/private/'

let cuppings_main_path = 'publicLiveCuppings_Main/'

const watchMyData = (state, uid) => {
  console.log('watchMyData', my_current_cupping + uid)
  // My Current Cupping Session (/cupping)
  firebaseInstance.database().ref(my_current_cupping + uid).on('value', (snap) => {
    let myCurrentCupping = snap.val()
    if (myCurrentCupping) { // 
      console.log('myCurrentCupping', myCurrentCupping)
      state.commit('AUTH.SET_MY_CURRENT_CUPPING', myCurrentCupping)
    } else { // create new cupping and send user there through /cupping
      console.log('create new own cupping')

      return new Promise(async (resolve, reject) => {
        let data = {newMyScoresheet: true}
        var saveProduct = firebase.functions().httpsCallable('saveLiveTastingProduct'); // *****
        saveProduct(data)
        .then((result) => {
          console.log('added my first scoresheet', result.data)
          // router.push('/live/' + result.data.updatedProductData.uniqueProductId)
          state.commit('AUTH.SET_MY_CURRENT_CUPPING', result.data.updatedProductData.uniqueProductId)
        })
        .catch((error) => {
          console.log('error saveLiveTastingProduct', error)
        });
      })

    }
  })

  // List of My Coffees
  firebaseInstance.database().ref(my_coffees_ref + uid).on('value', (snap) => {
    let mycoffees = snap.val()
    console.log('mycoffees', mycoffees)
    if (mycoffees) {
      state.commit('AUTH.SET_MY_COFFEES', mycoffees)
    } else if (mycoffees === null) {
      state.commit('AUTH.CLEAR_MY_COFFEES', {})
    }
  })

  // My Public Data
  firebaseInstance.database().ref(customer_info_path + uid).on('value', (snap) => {
    let data = snap.val()
    console.log('public data', data)
    if (data) {
      state.commit('AUTH.SET_MY_PUBLIC_DATA', data)
    } else if (data === null) {
      state.commit('AUTH.CLEAR_MY_PUBLIC_DATA', {})
    }
  })

  // My Private Data
  firebaseInstance.database().ref(customer_info_path2 + uid).on('value', (snap) => {
    let data = snap.val()
    console.log('private data', data)
    if (data) {
      state.commit('AUTH.SET_MY_PRIVATE_DATA', data)
    } else if (data === null) {
      state.commit('AUTH.CLEAR_MY_PRIVATE_DATA', {})
    }
  })
  // state.dispatch('FUNDS.getMyBalances')
  // firebaseInstance.database().ref('/games/' + (uid || 'failed')).on('child_added', (snap) => {
    // let data = snap.val()
    // console.log('games', data)
    // if (data) {
      // state.commit('GAMES.SET_MY_GAMES', data)
    // } else if (data === null) {
    //   state.commit('GAMES.CLEAR_MY_GAMES', {})
    // }
  // })
  // state.dispatch('FUNDS.getMyBalances')
}

const getToken = async () => {
    return firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
      return idToken
    }).catch(function(error) {
      return false
    });
}

const login = (email, password, state, then) => {
    var signIn = firebaseInstance.auth().signInWithEmailAndPassword(email, password)
    signIn.then((data) => {
      then && then()
    }).catch((error) => {
      console.log('Firebase Auth Error:', error)
      state.commit('AUTH.SET_AUTH_ERROR', error)
    })
}

const getLiveCuppingProductDetails = async (productId, state) => {
  return new Promise(async (resolve, reject) => {
    let run = async () => {
      let user = firebase.auth().currentUser
      if (user) {
        let uid = firebase.auth().currentUser.uid
        // let productDetailsRef = my_products_path + uid + '/' + productId
        // let _productDetails = await firebaseInstance.database().ref(productDetailsRef).once('value')
        // let productDetails = _productDetails.val()
        // console.log('test', uid, productDetails)
        // let uniqueProductId = productDetails.uniqueProductId
        let productFullDetailsRef = 'publicLiveCuppings_Main/' + productId
        let _productFullDetails = await firebaseInstance.database().ref(productFullDetailsRef).once('value')
        let _coffees = await firebaseInstance.database().ref('publicLiveCuppings_Coffees/' + productId).once('value')

        let productFullDetails = _productFullDetails.val()
        let coffees = _coffees.val()

        let options = productFullDetails.options
        options.coffees = coffees
        productFullDetails.options = options

        resolve(productFullDetails)
      } else {
        setTimeout(() => {
          run()
        }, 300)
      }
    }
    run()
  })
}

const AUTH = {

  checkout: (state, item) => {
    console.log('checkout', item)
    // return false
    return new Promise(async (resolve, reject) => {
      var exp_month = item.date.substr(0,2)
      var exp_year = item.date.substr(3,2)
      var exp_year = '20' + exp_year

      const data = item
      let ccData = {
            number: data.number, // 4242424242424242
            exp_month, // 12
            exp_year, // 2020
            cvc: data.cvv// 123
          }
      let ccOwner = {
        address : {
          city: data.addCCCity,
          country: data.addCCCountry,
          line1: data.addCCAddress,
          line2: data.addCCAddress2,
          postal_code: data.addCCPostalCode,
          state: data.addCCProvince,
        },
        name: data.addCCName || 'Test'
      }

      let _data = {
        password: item.password,
        createAccount: false,
        ccData,
        ccOwner,
        sourceid: 123,
        otherEmail: item.otherEmail,
        cart: {},
      }

      console.log('sending', _data)

      var checkout = firebase.functions().httpsCallable('checkout');
      checkout(_data)
      .then(async (result) => {
        // Read result of the Cloud Function.
        // var sanitizedMessage = result.data.text;
        // var sanitizedMessage = result;
        resolve(result)

        if (result.data && result.data.status == 400) {
          // state.commit('AUTH.SET_AUTH_ERROR', {message: result.data.message})
        } else {
          // state.commit('AUTH.CLEAR_AUTH_ERROR', {})
        }
        console.log('result', result)
      })
      .catch(async (error) => {
        // Getting the Error details.
        reject(error)
        console.log('error', error)
        // state.commit('AUTH.SET_AUTH_ERROR', {message: error.message})
        // var code = error.code;
        // var message = error.message;
        // var details = error.details;
        // ...
      });
    })
  },
  getLiveCuppingProductDetails: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let productDetails = await getLiveCuppingProductDetails(item, state)
      resolve(productDetails)
    })
  },
  getProPlan: (state, item) => {
    return new Promise(async (resolve, reject) => {
      var getProPlan = firebase.functions().httpsCallable('getProPlan');
      getProPlan(item)
      .then((result) => {
        resolve(result.data)
      })
      .catch((error) => {
        console.log('error getProPlan', error)
        resolve({message: 'Could not get Pro Plan.'})
      });
    })
  },
  getMyNews: (state, item) => {
    // var user = firebase.auth().currentUser
    // let uid = user.uid
    return new Promise(async (resolve, reject) => {
      // let my_fulfillments_path = global_news_path
      let _globalNews = await firebaseInstance.database().ref(global_news_path).once('value')
      let globalNews = _globalNews.val()

      let globalNewsArray = Object.keys(globalNews).map((v,i) => {
        return {
          ...globalNews[v], postid: v
        }
      })

      resolve(globalNewsArray)
    })
  },
  getMySessions: (state, item) => {
    var user = firebase.auth().currentUser
    let uid = user.uid
    return new Promise(async (resolve, reject) => {
      let my_fulfillments_path = my_products_path + uid
      let _fulfillments = await firebaseInstance.database().ref(my_fulfillments_path).once('value')
      let mySessions = _fulfillments.val()

      let fulfillmentsAsArray = Object.keys(mySessions || {}).map((v, i) => {
        return {...mySessions[v], orderId: v}
      })

      resolve({mySessions: fulfillmentsAsArray})
    })
  },
  getRecentSessions: (state, item) => {
    var user = firebase.auth().currentUser
    let uid = user.uid
    return new Promise(async (resolve, reject) => {
      let my_fulfillments_path = my_recently_viewed_sessions + uid
      console.log('getting this', my_fulfillments_path)
      let _fulfillments = await firebaseInstance.database().ref(my_fulfillments_path).once('value')
      let mySessions = _fulfillments.val()
      console.log('got', mySessions)

      let fulfillmentsAsArray = Object.keys(mySessions || {}).map((v, i) => {
        return {...mySessions[v], orderId: v}
      })
      console.log('got', fulfillmentsAsArray)

      resolve({mySessions: fulfillmentsAsArray})
    })
  },
  getUpcomingSessions: (state, item) => {
    var user = firebase.auth().currentUser
    let uid = user.uid
    return new Promise(async (resolve, reject) => {
      // let my_fulfillments_path = my_recently_viewed_sessions + uid
      console.log('getting this', cuppings_main_path)
      // ,,,
      let now = (new Date()).getTime()
      let _fulfillments = await firebaseInstance.database().ref(cuppings_main_path).orderByChild('startsAt').startAt(now).once('value')
      let mySessions = _fulfillments.val()
      console.log('got upcoming sessions', mySessions)

      let fulfillmentsAsArray = Object.keys(mySessions || {}).map((v, i) => {
        return {...mySessions[v], orderId: v}
      })
      console.log('got', fulfillmentsAsArray)

      resolve({mySessions: fulfillmentsAsArray})
    })
  },
  getPreviousSessions: (state, item) => {
    var user = firebase.auth().currentUser
    let uid = user.uid
    return new Promise(async (resolve, reject) => {
      // let my_fulfillments_path = my_recently_viewed_sessions + uid
      console.log('getting this', cuppings_main_path)
      // ,,,
      let now = (new Date()).getTime()
      let _fulfillments = await firebaseInstance.database().ref(cuppings_main_path).orderByChild('startsAt').endAt(now).once('value')
      let mySessions = _fulfillments.val()
      console.log('got upcoming sessions', mySessions)

      let fulfillmentsAsArray = Object.keys(mySessions || {}).map((v, i) => {
        return {...mySessions[v], orderId: v}
      }).filter(v => v.startsAt)
      console.log('got', fulfillmentsAsArray)

      resolve({mySessions: fulfillmentsAsArray})
    })
  },
  uploadProductImage: (state, item) => {
    return new Promise(async (resolve, reject) => {

      var user = firebase.auth().currentUser
      let uid = user.uid
      let file = item.file
      var extension = file.name
      extension = extension.substr(extension.lastIndexOf('.'), extension.length)
      let productId = item.productId

      let id = (new Date()).getTime()

      let run = async () => {
        let snapshot = await firebaseInstance.storage().ref('userProductImages').child(uid).child(id + extension).put(file)
        let url = await firebaseInstance.storage().ref('userProductImages').child(uid).child(id + extension).getDownloadURL()
        // await firebaseInstance.database().ref('/app/user_public_info/' + uid + '/profilePic').set(url)
        console.log('url', url)

        resolve({
          message: 'Image uploaded',
          url
        })
      }

      try {
        run()
      } catch (error) {
        reject ('Image upload error', error)
      }

    })
  },
  addRecentlyViewed: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var addRecentlyViewed = firebase.functions().httpsCallable('addRecentlyViewed');
      addRecentlyViewed(data)
      .then((result) => {
        resolve(result.data)
      })
      .catch((error) => {
        console.log('error addRecentlyViewed', error)
      });
    })
  },
  setNewPassword: (state, item) => {
    console.log('user', user.email)
    let user = firebase.auth().currentUser;
    let email = user.email
    let then = () => {
      user.updatePassword(item.password2).then(() => {
        console.log('new password set')
        let messageObject = {
          type: 'success',
          message: 'Success setting password!'
        }
        state.commit('AUTH.SET_FORM_MESSAGE', messageObject)
      }, (error) => {
        console.log('error setting password')
        let messageObject = {
          type: 'error',
          message: error
        }
        console.log('.....', messageObject)
        state.commit('AUTH.SET_FORM_MESSAGE', messageObject.message)
      })
    }
    var signIn = firebaseInstance.auth().signInWithEmailAndPassword(email, item.password)
    signIn.then((data) => {
      then && then()
    }).catch((error) => {
      then()
    })
  },
  saveProfile: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let {currentPassword,newPassword,newPasswordConfirm, ...data} = item

      var saveProfile = firebase.functions().httpsCallable('saveProfile');
      saveProfile(data)
      .then((result) => {
        console.log('res', result)
        // resolve(result)
      })
      .catch((error) => {
        console.log('error saveProfile', error)
      })

      if (currentPassword || newPassword || newPasswordConfirm) {
        if (currentPassword && newPassword) {
          // auth again + set new password
          if (newPassword !== newPasswordConfirm) {
            return resolve({message: `Passwords don't match`})
          }
          console.log('set new pw')

          let user = firebase.auth().currentUser;
          let email = user.email

          let then = () => {
            user.updatePassword(newPassword).then(() => {
              console.log('new password set')
              return resolve('ok')
            }, (error) => {
              console.log('error setting password', error)
              return resolve(error)
            })
          }
          console.log('em', email, newPassword)
          var signIn = firebaseInstance.auth().signInWithEmailAndPassword(email, currentPassword)
          signIn.then((data) => {
            then && then()
          }).catch((error) => {
            // then()
            return resolve(error)
          })

        } else {
          return resolve({message: 'Please enter your current and new password'})
        }
      }
    })
  },
  saveLiveTastingProduct: (state, item) => {
    console.log('saveLiveTastingProduct action')
    return new Promise(async (resolve, reject) => {
      let data = item
      var saveProduct = firebase.functions().httpsCallable('saveLiveTastingProduct');
      saveProduct(data)
      .then((result) => {
        resolve(result.data.updatedProductData)
      })
      .catch((error) => {
        console.log('error saveLiveTastingProduct', error)
      });
    })
  },
  deactivateProduct: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var saveProduct = firebase.functions().httpsCallable('deactivateProduct');
      saveProduct(data)
      .then((result) => {
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error deactivateProduct', error)
      });
    })
  },
  deactivateLiveTastingProduct: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var saveProduct = firebase.functions().httpsCallable('deactivateLiveTastingProduct');
      saveProduct(data)
      .then((result) => {
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error deactivateLiveTastingProduct', error)
      });
    })
  },
  updateMyDescriptors: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      console.log('updateMyDescriptors', data)
      var updateMyDescriptors = firebase.functions().httpsCallable('updateMyDescriptors');
      updateMyDescriptors(data)
      .then((result) => {
        console.log('result', result)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error updateMyDescriptors', error)
      });
    })
  },
  replyToQuestion: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var replyToQuestion = firebase.functions().httpsCallable('replyToQuestion');
      replyToQuestion(data)
      .then((result) => {
        console.log('result', replyToQuestion)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error replyToQuestion', error)
      });
    })
  },
  trashComment: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var trashComment = firebase.functions().httpsCallable('trashComment');
      trashComment(data)
      .then((result) => {
        console.log('result', trashComment)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error trashComment', error)
      });
    })
  },
  trashReply: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var trashReply = firebase.functions().httpsCallable('trashReply');
      trashReply(data)
      .then((result) => {
        console.log('result', trashReply)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error trashReply', error)
      });
    })
  },
  deleteComment: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var deleteComment = firebase.functions().httpsCallable('deleteComment');
      deleteComment(data)
      .then((result) => {
        console.log('result', deleteComment)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error deleteComment', error)
      });
    })
  },
  deleteReply: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var deleteReply = firebase.functions().httpsCallable('deleteReply');
      deleteReply(data)
      .then((result) => {
        console.log('result', deleteReply)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error deleteReply', error)
      });
    })
  },
  askAQuestion: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var askAQuestion = firebase.functions().httpsCallable('askAQuestion');
      askAQuestion(data)
      .then((result) => {
        console.log('result', askAQuestion)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error askAQuestion', error)
      });
    })
  },
  markAsQuestion: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var markAsQuestion = firebase.functions().httpsCallable('markAsQuestion');
      markAsQuestion(data)
      .then((result) => {
        console.log('result', markAsQuestion)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error markAsQuestion', error)
      });
    })
  },
  setNewScore: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      
      let db = firebaseInstance.database()
      let uid = firebase.auth().currentUser.uid
      let now = (new Date()).getTime()

      let session = data.session
      let n = data.n
      let i = data.i
      let j = data.j
      let val = data.val

      console.log('setNewScore', data.val)

      let public_products_ref = 'publicLiveCuppings_Scores/' +
                               (Number.isNaN(session) ? 'f' : session) + '/scores/' + 
                                (uid || 'f') + '/coffees/' +
                                (Number.isNaN(n) ? 'f' : n) + '/steps/' + 
                                (Number.isNaN(i) ? 'f' : i) + '/metrics/' + 
                                (Number.isNaN(j) ? 'f' : j) + '/score'

      if (typeof val == 'object') {
        await db.ref(public_products_ref).update(val)
      } else {
        await db.ref(public_products_ref).set(val)
      }


      return {
          message: 'ok',
      }
      // var markAsQuestion = firebase.functions().httpsCallable('markAsQuestion');
      // markAsQuestion(data)
      // .then((result) => {
      //   console.log('result', markAsQuestion)
      //   resolve(result.data.message)
      // })
      // .catch((error) => {
      //   console.log('error markAsQuestion', error)
      // });
    })
  },
  pushRevealCoffees: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var pushRevealCoffees = firebase.functions().httpsCallable('pushRevealCoffees');
      pushRevealCoffees(data)
      .then((result) => {
        console.log('result', pushRevealCoffees)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error pushRevealCoffees', error)
      });
    })
  },
  pushLockScoring: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var pushLockScoring = firebase.functions().httpsCallable('pushLockScoring');
      pushLockScoring(data)
      .then((result) => {
        console.log('result', pushLockScoring)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error pushLockScoring', error)
      });
    })
  },
  pushLockScoringStart: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var pushLockScoringStart = firebase.functions().httpsCallable('pushLockScoringStart');
      pushLockScoringStart(data)
      .then((result) => {
        console.log('result', pushLockScoringStart)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error pushLockScoringStart', error)
      });
    })
  },
  endSession: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var endSession = firebase.functions().httpsCallable('endSession');
      
      endSession(data)
      .then((result) => {
        console.log('result', endSession)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error endSession', error)
      });
    })
  },
  pushShowAverageScores: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var pushShowAverageScores = firebase.functions().httpsCallable('pushShowAverageScores');
      pushShowAverageScores(data)
      .then((result) => {
        console.log('result', result)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error pushShowAverageScores', error)
      });
    })
  },
  pushShowGroupDescriptors: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var pushShowGroupDescriptors = firebase.functions().httpsCallable('pushShowGroupDescriptors');
      pushShowGroupDescriptors(data)
      .then((result) => {
        console.log('result', pushShowGroupDescriptors)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error pushShowGroupDescriptors', error)
      });
    })
  },
  pushShowPolarization: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var pushShowPolarization = firebase.functions().httpsCallable('pushShowPolarization');
      pushShowPolarization(data)
      .then((result) => {
        console.log('result', pushShowPolarization)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error pushShowPolarization', error)
      });
    })
  },
  plusOneAQuestion: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var plusOneAQuestion = firebase.functions().httpsCallable('plusOneAQuestion');
      plusOneAQuestion(data)
      .then((result) => {
        console.log('result', plusOneAQuestion)
        resolve(result.data.message)
      })
      .catch((error) => {
        console.log('error plusOneAQuestion', error)
      });
    })
  },
  authStateChange: (state, item) => {
    firebaseInstance.auth().onAuthStateChanged(user => {
      let pushPaths = [
        '/',
        '/login',
        '/?auth=register',
        '/?auth=login'
        // '/?auth=pro&pro=getpro',
        // '/pay'
      ]
      if (user) {
        state.commit('AUTH.UID_NOT_PRESENT', false)
        console.log("AUTH status: logged in", user.uid, router.currentRoute.path)
        console.log("AUTH status: logged in", user.isAnonymous)
        // console.log('user', user)
        state.commit('AUTH.CLEAR_AUTH_ERROR', {})
        state.commit('AUTH.SET_UID', user.uid)
        state.commit('AUTH.SET_EMAIL', user.email)
        if (user.isAnonymous) {
          state.commit('AUTH.SET_ANON', true)
        } else {
          state.commit('AUTH.SET_ANON', false)
        }
        // state.commit('AUTH.SET_EMAIL', user.email)
        watchMyData(state, user.uid)
        // console.log('router****', router.currentRoute)
        // return
        let nextPath = router.currentRoute.query.nextPath
        if (nextPath) {
          // console.log('nextPath', nextPath)
          // http://localhost:8080/?auth=register&then=2RyBb48m
          router.push(nextPath)
        } else if (router.currentRoute.query.then) {
          if (user.isAnonymous) {

          } else {
            router.push('/live/' + router.currentRoute.query.then)
          }
        } else {
          // console.log('.........', router.currentRoute)
          // console.log('.....', (pushPaths.indexOf(router.currentRoute.fullPath) > -1))
          // console.log('.....2', (!user.isAnonymous && (pushPaths.indexOf(router.currentRoute.path) > -1)))
          if (!user.isAnonymous && (pushPaths.indexOf(router.currentRoute.fullPath) > -1)) {
            // console.log('pushing.....')
            router.push('/me')
          }
        }
      } else {
        console.log("AUTH status: not logged in.")
        state.commit('AUTH.UID_NOT_PRESENT', true)
        console.log('here', router.currentRoute)
        if (router.currentRoute.name == 'PayPage') {
          //
        } else if (pushPaths.indexOf(router.currentRoute.path) < 0) {
          console.log('test', router.currentRoute.name)
          if (router.currentRoute.name == 'LivePage') {
            console.log('test2')
            firebaseInstance.auth().signInAnonymously()
          } else {
            router.push('/')
          }
        }
      }
    });
  },
  flipColorMode: (state, item) => {
    state.commit('AUTH.FLIP_COLOR_MODE', item)
  },
  showHeaderShop: (state, item) => {
    state.commit('AUTH.SHOW_HEADER_SHOP', item)
  },
  showCuppingSettings: (state, item) => {
    state.commit('AUTH.SHOW_CUPPING_SETTINGS', item)
  },
  register: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let anon = item.anon
      if (anon && firebase.auth().currentUser) {

        var credential = firebase.auth.EmailAuthProvider.credential(item.email, item.password);
        firebase.auth().currentUser.linkWithCredential(credential)
          .then((usercred) => {
            var user = usercred.user;
            console.log("Anonymous account successfully upgraded", user);
            router.push('/me')
          }).catch((error) => {
            console.log("Error upgrading anonymous account", error);
            return reject(error)
          });

      } else {
        var register = firebaseInstance.auth().createUserWithEmailAndPassword(item.email, item.password)
        register.then((user) => {
          console.log('user', user)
        }).catch((message) => {
          return reject(message)
        })   
      }
    })
  },
  cancelSubscription: (state, item) => {
    let data = item
    return new Promise(async (resolve, reject) => {
      var cancelSubscription = firebase.functions().httpsCallable('cancelSubscription');
      cancelSubscription(data)
      .then((result) => {
        resolve(result.data)
      })
      .catch((error) => {
        console.log('error cancelSubscription', error)
      });
    })
  },

  submitMessage: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var submitMessage = firebase.functions().httpsCallable('submitMessage');
      submitMessage(data)
      .then((result) => {
        resolve(result.data)
      })
      .catch((error) => {
        console.log('error submitMessage', error)
      });
    })
  },
  submitEmail: (state, item) => {
    return new Promise(async (resolve, reject) => {
      let data = item
      var submitEmail = firebase.functions().httpsCallable('submitEmail');
      submitEmail(data)
      .then((result) => {
        resolve(result.data)
      })
      .catch((error) => {
        console.log('error submitEmail', error)
      });
    })
  },
  login: (state, item) => {
    console.log('*** signin ***', item)
    return new Promise(async (resolve, reject) => {
      let then = () => {
        var signIn = firebaseInstance.auth().signInWithEmailAndPassword(item.email, item.password)
        signIn.then((data) => {
          return resolve(data)
        }).catch((error) => {
          console.log('here?')
          return reject(error)
        })
       } 
      state.dispatch('AUTH.logout', then)
    })
  },

  logout: (state, item) => {
    firebaseInstance.auth().signOut().then(() => {
      state.commit('AUTH.CLEAR_STATE', {})
      console.log('Signed out', item)
      if ((typeof item) == 'function') {
        item()
      }
    }, (error) => {
      console.log('Error when logging out', error)
    })
  },
}

export default AUTH


// WEBPACK FOOTER //
// ./src/services/AUTH/actions/index.js